import React, { Component } from "react";
import PropTypes from "prop-types";

class RadioButtonGroup extends Component {
  render() {
    const { groupItems, onChange } = this.props;
    let radioButtons = null;

    if (groupItems) {
      radioButtons = (
        <div className="row text-left text-sm-center text-md-left text-lg-center justify-content-center">
          {groupItems.map((radioButton, index) => {
            return (
              <div className="col-12  col-sm-4 col-md-12 col-lg-4 col-xl-3 mt-2 mm-teaser-input-margin" key={index}>
                <label className="mm-teaser-label">
                  <input
                    type="radio"
                    className="mm-teaser-radio-button"
                    name={radioButton.name}
                    value={radioButton.value}
                    autoComplete="off"
                    onChange={onChange}
                    id={index}
                  />
                  <div
                    className="mm-teaser-label mm-teaser-input h-100 d-flex d-sm-block d-md-flex  d-lg-block align-items-center"
                    htmlFor={index}>
                    <div className="mm-image mr-2 mr-lg-0"><img src={process.env.GATSBY_STRAPI_PUBLIC_URL + radioButton.imageUrl} /></div>
                    <div>
                      <div className="mm-title mt-md-2">{radioButton.label.title}</div>
                      <div className="mm-subtitle mt-lg-2">{radioButton.label.subtitle}</div>
                    </div>
                  </div>
                </label>
              </div>
            );
          })}
        </div>
      );
    }

    return <div className="loadTypeRadioGroup">{radioButtons}</div>;
  }
}

export default RadioButtonGroup;
